"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapKey(subject, callbackfn, thisArg) {
    return Object.keys(subject).map(callbackfn, thisArg);
}
exports.mapKey = mapKey;
//# sourceMappingURL=mapKey.js.map